module.exports = __webpack_public_path__ + "static/media/UserWelcome.2af7a4c4.png";